/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentRenegotiationParcelViewModel } from "../types/IndividualPaymentRenegotiationParcelViewModel.ts";

export const individualPaymentRenegotiationParcelViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  totalValue: z.optional(z.number()),
  totalDiscount: z.optional(z.number()),
  numberParcel: z.optional(z.number().int()),
  lastOpenDate: z.string().datetime().nullish(),
}) as unknown as ToZod<IndividualPaymentRenegotiationParcelViewModel>;
